module.exports = __webpack_public_path__ + "img/GI.5746f93c.png";